<div class="store-overview">
  <div class="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
    <div>
      <h4>{{ 'KPI.OVERVIEW.TITLE' | translate }}</h4>
      <p class="text-muted mb-0">{{ 'KPI.OVERVIEW.SUBTITLE' | translate }}</p>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm"
      (click)="openConfigureDialog()"
      [disabled]="loading || preferencesLoading">
      <nb-icon icon="settings-2-outline" class="me-1"></nb-icon>
      {{ 'KPI.OVERVIEW.CONFIGURE_KPIS' | translate }}
    </button>
  </div>

  <nb-card class="mb-4">
    <nb-card-body>
      <app-report-filter-bar
        [filterValue]="filterState"
        [disabled]="loading || preferencesLoading"
        (filterChange)="onFilterChange($event)">
      </app-report-filter-bar>
      <app-kpi-saved-views-bar
        scope="store"
        i18nPrefix="KPI.OVERVIEW"
        [savedViews]="savedViews"
        [currentFilter]="filterState"
        [disabled]="loading || preferencesLoading"
        (viewApplied)="onSavedViewApplied($event)"
        (savedViewsChange)="onSavedViewsChange($event)">
      </app-kpi-saved-views-bar>
    </nb-card-body>
  </nb-card>

  <div *ngIf="loading || preferencesLoading" class="text-center py-5">
    <nb-spinner size="large"></nb-spinner>
    <p class="mt-3 text-muted">{{ 'KPI.OVERVIEW.LOADING' | translate }}</p>
  </div>

  <ng-container *ngIf="!loading && !preferencesLoading">
    <!-- Status strip -->
    <div class="status-strip mb-4">
      <span class="status-chip status-completed">
        {{ 'KPI.OVERVIEW.STATUS_COMPLETED' | translate }}:
        <strong>{{ formatMetric('completedOrders', getNogletalValue('completedOrders')) }}</strong>
      </span>
      <span class="status-chip status-processing">
        {{ 'KPI.OVERVIEW.STATUS_PROCESSING' | translate }}:
        <strong>{{ formatMetric('processingOrders', getNogletalValue('processingOrders')) }}</strong>
      </span>
      <span class="status-chip status-paid-incomplete">
        {{ 'KPI.OVERVIEW.STATUS_PAID_INCOMPLETE' | translate }}:
        <strong>{{ formatMetric('paidIncompleteOrders', getNogletalValue('paidIncompleteOrders')) }}</strong>
      </span>
    </div>

    <!-- Configurable tiles -->
    <div class="row mb-4" *ngIf="storeTileKeys.length">
      <div class="col-lg-3 col-md-6 mb-3" *ngFor="let key of storeTileKeys">
        <nb-card class="tile-card h-100">
          <nb-card-body>
            <div class="d-flex align-items-start">
              <div class="tile-icon me-3">
                <nb-icon [icon]="tileIcon(key)"></nb-icon>
              </div>
              <div>
                <div class="tile-label text-muted">{{ metricLabelKey(key) | translate }}</div>
                <div class="tile-value">{{ formatMetric(key, getTileValue(key)) }}</div>
              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </div>

    <div class="row">
      <!-- Nøgletal panel -->
      <div class="col-lg-5 mb-4">
        <nb-card class="h-100 nogletal-card">
          <nb-card-header>{{ 'KPI.OVERVIEW.NOGLETAL_TITLE' | translate }}</nb-card-header>
          <nb-card-body>
            <div *ngFor="let group of nogletalGroups" class="nogletal-group mb-4">
              <h6 class="group-title">{{ 'KPI.OVERVIEW.GROUP_' + group.key.toUpperCase() | translate }}</h6>
              <div class="nogletal-row" *ngFor="let metricKey of group.metrics">
                <span class="nogletal-label">{{ metricLabelKey(metricKey) | translate }}</span>
                <span class="nogletal-value">{{ formatMetric(metricKey, getNogletalValue(metricKey)) }}</span>
              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>

      <!-- Evolution chart -->
      <div class="col-lg-7 mb-4">
        <nb-card class="h-100">
          <nb-card-header>{{ 'KPI.OVERVIEW.EVOLUTION_CHART' | translate }}</nb-card-header>
          <nb-card-body>
            <div class="chart-container" *ngIf="dailyTrend.length; else noTrend">
              <canvas
                baseChart
                #trendChart="base-chart"
                [data]="trendChartData"
                [options]="trendChartOptions"
                [type]="trendChartType">
              </canvas>
            </div>
            <ng-template #noTrend>
              <div class="text-center text-muted py-5">
                {{ 'KPI.OVERVIEW.NO_TREND_DATA' | translate }}
              </div>
            </ng-template>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </ng-container>
</div>
